import type { JSX } from 'react'

export const HomeIcon = ({ filled }: { filled?: boolean }): JSX.Element => (
  <>
    <use
      href='#homeSolidIcon'
      height='100%'
      width='100%'
      fillOpacity={!filled ? 0 : 1}
    />
    <use href='#homeIcon' height='100%' width='100%' />
  </>
)
